import { keyframes } from "styled-components/macro";

export const overlayFadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const popoverSlideIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(50vh);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const overlayFadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const popoverSlideOut = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(50vh);
  }
`;
